export default __webpack_public_path__ + "static/media/StarUnfill.dc810836.svg";